<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

    <ng-container *ngIf="consulta">

        <ul class="card-list-striped">
            <li>
                <span class="text-secondary">Placa</span>
                <span>{{consulta?.placa || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Renavam</span>
                <span>{{consulta?.renavam || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Ano Fabricação</span>
                <span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Ano Modelo</span>
                <span>{{consulta?.anoModelo || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Proprietário Atual</span>
                <span>{{consulta?.proprietario || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Proprietário Anterior</span>
                <span>{{consulta?.proprietarioAnterior || "NÃO INFORMADO"}}</span>
            </li>
        </ul>

        <div class="mb-2">
            <div class="bg-light p-2">
                <span class="text-primary fw-500">Obs: </span>
                <span>{{consulta?.observacao || "NÃO INFORMADO"}}</span>
            </div>
        </div>

        <div *ngFor="let m of consulta?.listaMulta; let i = index">

            <h2 class="subtitle subtitle-danger"> {{ i+1 }} MULTA - {{m?.descricao || "NÃO INFORMADO"}}</h2>

            <ul class="card-list-striped">
                <li>
                    <span class="text-secondary">Local</span>
                    <span>{{m?.local || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Valor</span>
                    <span>{{m?.valor || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Código</span>
                    <span>{{m?.codigo || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Data</span>
                    <span>{{m?.data || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Municipio</span>
                    <span>{{m?.municipio || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Incluida Em</span>
                    <span>{{m?.incluidaEm || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Situação</span>
                    <span>{{m?.situacao || "NÃO INFORMADO"}}</span>
                </li>
                <li>
                    <span class="text-secondary">Orgão</span>
                    <span>{{m?.orgao || "NÃO INFORMADO"}}</span>
                </li>
            </ul>
        </div>


        <div *ngIf="consulta?.listaDebito.length > 0">

            <h2 class="subtitle subtitle-warning"> DÉBITOS </h2>

            <div *ngFor="let d of consulta?.listaDebito; let i = index" class="bg-o-danger row">
                <div class="col-12 col-md-6 p-1">
                    <span class="text-secondary">Tipo: </span>
                    <div>{{d?.tipo || "NÃO INFORMADO"}}</div>
                </div>
                <div class="col-6 p-1 col-md-3">
                    <span class="text-secondary">Valor</span>
                    <div>{{d?.valor || "NÃO INFORMADO"}}</div>
                </div>
                <div class="col-6 p-1 col-md-3">
                    <span class="text-secondary">Código</span>
                    <div>{{d?.codigo || "NÃO INFORMADO"}}</div>
                </div>
            </div>
        </div>

    </ng-container>

</app-card-consulta>
